import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UpdateRegistrationContactPage } from './update-registration-contact';

import { BrMaskerModule } from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    UpdateRegistrationContactPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationContactPage),
    BrMaskerModule,
  ],
  exports: [
    UpdateRegistrationContactPage
  ]
})
export class UpdateRegistrationContactPageModule { }



// WEBPACK FOOTER //
// ./src/pages/update-registration-contact/update-registration-contact.module.ts